var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기본정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: "",
                        disabled: _vm.disabled,
                        editable:
                          _vm.editable && (_vm.requestEditable || !_vm.isOld),
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.fireFightingIssueCheck.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingIssueCheck, "plantCd", $$v)
                        },
                        expression: "fireFightingIssueCheck.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: "",
                        disabled: _vm.disabled,
                        editable:
                          _vm.editable && (_vm.requestEditable || !_vm.isOld),
                        default: "today",
                        type: "month",
                        name: "yearmonth",
                        label: "점검년월",
                      },
                      on: { datachange: _vm.checkNameWrite },
                      model: {
                        value: _vm.fireFightingIssueCheck.yearmonth,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingIssueCheck, "yearmonth", $$v)
                        },
                        expression: "fireFightingIssueCheck.yearmonth",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-dept", {
                      attrs: {
                        required: "",
                        disabled: _vm.disabled,
                        editable:
                          _vm.editable && (_vm.requestEditable || !_vm.isOld),
                        type: "edit",
                        label: "점검부서",
                        name: "deptCd",
                      },
                      on: {
                        datachange: (deptCd, deptName) =>
                          _vm.checkNameWrite("D", deptName),
                      },
                      model: {
                        value: _vm.fireFightingIssueCheck.deptCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingIssueCheck, "deptCd", $$v)
                        },
                        expression: "fireFightingIssueCheck.deptCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: "",
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        label: "점검명",
                        name: "issueCheckName",
                      },
                      model: {
                        value: _vm.fireFightingIssueCheck.issueCheckName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.fireFightingIssueCheck,
                            "issueCheckName",
                            $$v
                          )
                        },
                        expression: "fireFightingIssueCheck.issueCheckName",
                      },
                    }),
                  ],
                  1
                ),
                _vm.isOld &&
                _vm.fireFightingIssueCheck.sopFireFightingIssueStepCd !==
                  "FFI0000001"
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable && _vm.confirmEditable,
                            rows: 1,
                            label: "이슈종합내용",
                            name: "issueContents",
                          },
                          model: {
                            value: _vm.fireFightingIssueCheck.issueContents,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.fireFightingIssueCheck,
                                "issueContents",
                                $$v
                              )
                            },
                            expression: "fireFightingIssueCheck.issueContents",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isOld &&
                _vm.fireFightingIssueCheck.sopFireFightingIssueStepCd !==
                  "FFI0000001"
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable && _vm.completeEditable,
                            rows: 1,
                            label: "검토내용",
                            name: "confirmContents",
                          },
                          model: {
                            value: _vm.fireFightingIssueCheck.confirmContents,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.fireFightingIssueCheck,
                                "confirmContents",
                                $$v
                              )
                            },
                            expression:
                              "fireFightingIssueCheck.confirmContents",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
          _c(
            "c-table",
            {
              ref: "table",
              staticClass: "q-mt-sm",
              attrs: {
                title: _vm.resultTableTitle,
                columns: _vm.grid.columns,
                gridHeightAuto: "",
                data: _vm.fireFightingIssueCheck.targets,
                isTitle: true,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable && !_vm.disabled,
                selection: "multiple",
                rowKey: "sopFireFightingIssueCheckTargetId",
              },
              on: { linkClick: _vm.linkClick },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && (_vm.requestEditable || !_vm.isOld)
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "추가",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addTarget },
                          })
                        : _vm._e(),
                      _vm.editable && (_vm.requestEditable || !_vm.isOld)
                        ? _c("c-btn", {
                            attrs: {
                              disabled:
                                !_vm.fireFightingIssueCheck.targets ||
                                _vm.fireFightingIssueCheck.targets.length === 0,
                              label: "제외",
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.deleteTarget },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable && _vm.confirmEditable,
                      expression: "editable&&confirmEditable",
                    },
                  ],
                  attrs: {
                    flat: "",
                    url: _vm.confirmUrl,
                    isSubmit: _vm.isConfirm,
                    param: _vm.fireFightingIssueCheck,
                    mappingType: "PUT",
                    label: "검토요청",
                    icon: "check",
                  },
                  on: {
                    beforeAction: _vm.confirmInfo,
                    btnCallback: _vm.confirmCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }